export default __webpack_public_path__ + "static/media/image-grupos.8b1bbc46.png";